export default function 
useUrl() {
  const Url = new URL (window.location.href);

  const isCurrentUrl = (url: string): boolean =>
    // url === Url.pathname;  
    Url.pathname.includes(url);  

  const chooseCurrentTab = <T extends string>(tabs: T[]): T | undefined =>
    tabs.find((tab) => isCurrentUrl(`/${tab}`));

  const getPathnameChain = (url?: string): string[] | undefined => (url ? new URL (url) : Url)?.pathname?.split('/');

  const getPreviousPath = (url?: string): string | undefined => getPathnameChain(url)?.slice(0, -1)?.join('/');

  return {
    isCurrentUrl,
    chooseCurrentTab,
    getPathnameChain,
    getPreviousPath,
  };
};